<bootstrap-popup [id]="id" [displaySubject]="displaySubject" 
	[title]="'Informations du plan de prévention n° ' + numeroPdp + ' - ' + (parcCodes.indexOf(',') > -1 ? 'Parcs ' : 'Parc ') + parcCodes" >

	<pannel [title]="'Travaux'" [expandable]="true">
		<div class="travaux" *ngFor="let tr of travaux">
			<div class="col-sm-12">
				<h3>{{ tr.designation }}</h3>
				<table class="col-sm-6 entreprises" >
					<tr><th>Entreprises</th></tr>
					<tr *ngFor="let entreprise of tr.entreprisesConcernees">
						<td class="table-cell">{{ entreprise.nom }}</td>
					</tr>
				</table>
				<table class="col-sm-6 sousTraitants" >
					<tr><th>Sous-traitants</th></tr>
					<tr *ngFor="let sousTraitant of tr.sousTraitantsConcernes">
						<td class="table-cell">{{ sousTraitant.nom }}</td>
					</tr>
				</table>
			</div>
		</div>
	</pannel>
	
	<ng-container [ngTemplateOutlet]="valideurSignatairesApplicable() ? blocSignatairesGeneral : blocIntervenants"></ng-container>
        
	<div class="row">
		<div class="col-md-12">
			<div class="form-group text-center">
				<button type="button" class="btn btn-primary" style="margin-right: 10px" (click)="onCloseRequested()">
					Fermer
				</button>
			</div>
		</div>
	</div>

</bootstrap-popup>

<ng-template #blocSignatairesGeneral>
<pannel [title]="'Valideurs'" [expandable]="true">
	<div class="col-sm-12 signataires" *ngFor="let entreprise of entreprises">
		<table class="col-sm-6 entreprise" *ngIf="valideurs[entreprise.id]">
			<tr><th>{{ entreprise.raisonSociale }}</th></tr>
			<tr *ngFor="let valideur of valideurs[entreprise.id]">
				<td [ngClass]="valideur.hasSigned ? 'hasSigned table-cell' : 'hasNotSigned table-cell'">{{ valideur.nom }} {{ valideur.prenom }}</td>
			</tr>
		</table>
	</div>
</pannel>
<pannel [title]="'Representants'" [expandable]="true">
	<div class="col-sm-12 signataires" *ngFor="let entreprise of entreprises">
		<table class="col-sm-6 entreprise" *ngIf="representants[entreprise.id]">
			<tr><th>{{ entreprise.raisonSociale }}</th></tr>
			<tr *ngFor="let representant of representants[entreprise.id]">
				<td [ngClass]="representant.hasSigned ? 'hasSigned table-cell' : 'hasNotSigned table-cell'">{{ representant.intervenantNom }} {{ representant.intervenantPrenom }}</td>
			</tr>
		</table>
	</div>
</pannel>
<ng-container [ngTemplateOutlet]="blocIntervenants"></ng-container>
</ng-template>

<ng-template #blocIntervenants>
<pannel [title]="'Intervenants'" [expandable]="true">
	<div class="col-sm-12 signataires" *ngFor="let entreprise of entreprises">
		<table class="col-sm-6 entreprise" *ngIf="intervenants[entreprise.id]">
			<tr><th>{{ entreprise.raisonSociale }}</th></tr>
			<tr *ngFor="let intervenant of intervenants[entreprise.id]">
				<td [ngClass]="intervenant.hasSigned ? 'hasSigned table-cell' : 'hasNotSigned table-cell'">{{ intervenant.nom }} {{ intervenant.prenom }}</td>
			</tr>
		</table>
	</div>
</pannel>
</ng-template>
